<template>
    <div>
        <div class="row ix-custom-form-container">
            <div class="col-sm-12 col-md-3">
                <div class="form-group row">
                    <label for="payment_payable_type" class="col-sm-12 col-form-label required"> Type d'objet</label>
                    <div class="col-sm-12">
                            <select  @change="onChange()" name="payment[payable_type]" id="payment_payable_type" class="form-control" v-model="form.payable_type">
                                <option :value="TYPE_PAYABLE_INVOICE">Facture client</option>
                                <option :value="TYPE_PAYABLE_BILL">Facture fournisseur</option>
                                <option :value="TYPE_PAYABLE_CREDIT_NOTE_CLIENT" data-spec='dedit'>Avoir client</option>
                                <option :value="TYPE_PAYABLE_CREDIT_NOTE_PROVIDER" data-spec='credit'>Avoir fournisseur</option>
                                <option :value="TYPE_PAYABLE_RG">Retenue de garantie</option>
                            </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-3">
                <div class="form-group row">
                      <label for="payment_type" class="col-sm-12 col-form-label">Type</label>
                        <div class="col-sm-12">
                            <select name="payment[type]" id="payment_type" class="form-control" v-model="form.type">
                                <option value="1">Crédit</option>
                                <option value="2">Débit</option>
                            </select>
                        </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-12">
                <div class="form-group row">
                    <label for="payment_payable_label" class="col-sm-12 col-form-label">Recherche</label>
                    <div class="col-sm-12"> 
                        <input placeholder="Commencer la saisie pour obtenir des suggestions (désignation,société,montant) .." onkeydown="return event.key != 'Enter';" class="form-control" id="autocompleteSearchInput" type="text" v-model="form.search">
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-md-12">
                <div class="alert alert-warning">Pour le règlement d’une facture client qui prévoit un eventuel escompte, il est nécessaire de vous rendre sur la facture puis de cliquer sur “Enregistrer paiement” </div>
            </div>
 

            <div class="col-sm-12 col-md-12">
                <div class="ix-table-box mb-4 mt-4">
                    <table class="ix-table ix-table-align-middle">
                            <thead>
                                <tr>
                                    <th>Désignation</th>
                                    <th>Société</th>
                                    <th class="text-right">Total HT</th>
                                    <th class="text-right">Total TTC</th>
                                    <th class="text-right">Reste à payer</th>
                                    <th class="text-right">Montant</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="lines && lines.length == 0" class="text-center">
                                    <td colspan="8">Veuillez renseigner des factures ou des avoirs</td>
                                </tr>
                                <tr v-for="(line,index) in lines"  is="payable-line" :key="index"
                                    :line="line"
                                    :index="index"
                                     v-on:line-deleted="deleteRow($event)">
                                </tr>
                               
                            </tbody>
                            <tfoot>
                                 <tr v-if="lines && lines.length != 0" class="text-right" style="background: #f6f8fa">
                                    <td colspan="8" style="padding: 15px !important">Total : <b>{{ currency(total_amount) }}</b></td>
                                </tr>
                            </tfoot>
                    </table>
                </div>
            </div>

        </div>
    </div>
        
</template>

<script>

import $ from 'jquery'
import PayableLine from "./PayableLine";
import Swal from "sweetalert2";

export default {
    name: 'payment-component',
    props: ['route', 'oldLines', 'paymentTypes'],
    data() {
        return {
            TYPE_PAYABLE_INVOICE : 0,
            TYPE_PAYABLE_BILL : 1,
            TYPE_PAYABLE_CREDIT_NOTE_CLIENT : 2,
            TYPE_PAYABLE_CREDIT_NOTE_PROVIDER : 3,
            TYPE_PAYABLE_RG : 4,
            form : {
                payable_type : 0,
                search: null,
                type: 1, // Crédit par défaut car facture client
            },
            lines :[],
            typePayments: this.paymentTypes,
            oldPayableType: null,
            arrayType : ['App\\Models\\Invoice', 'App\\Models\\Bill', 'App\\Models\\CreditNote', 'App\\Models\\CreditNote']
        }
    },
    components : {
        PayableLine
    },
   watch: {
        'form.payable_type' :function(newValue, oldValue){
            this.oldPayableType = oldValue;
        }
    },
    computed: {
        total_amount: function() {
            var sum = 0;
            this.lines.forEach(line => sum += parseFloat(line.amount));
            return sum;
        },
    },
    methods: {
        onChange(){
            if(this.lines && this.lines.length > 0){
                   Swal.fire({
                    title: 'Attention',
                    text: "Le contenu renseigné sera définitivement perdu, souhaitez-vous continuer ?",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.lines = [];
                        this.changeForm();
                    } else {
                        this.form.payable_type = this.oldPayableType;
                    }
                })
            } else {
                this.changeForm();   
            }
        },
        changeForm(){
            if(this.form.payable_type == this.TYPE_PAYABLE_CREDIT_NOTE_CLIENT || this.form.payable_type == this.TYPE_PAYABLE_CREDIT_NOTE_PROVIDER){
                this.form.type = $("#payment_payable_type option:selected").data("spec") == 'credit' ? 1 : 2;
            } else if(this.form.payable_type == this.TYPE_PAYABLE_INVOICE || this.form.payable_type == this.TYPE_PAYABLE_RG) {
                this.form.type = 1;
            } else {
                this.form.type = 2
            }
        },
        addLine: function (line) {
            if (this.getCurrentSelectedLinesId().includes(line.id) == false) {
                this.lines.push({
                    id: line.id,
                    designation: line.full_designation,
                    total_ht: line.total_ht,
                    total_ttc: line.total_ttc,
                    class: line.class,
                    company_id: line.company_id,
                    company_designation: line.company_designation,
                    total_remaining: line.total_remaining,
                    amount: 0,
                });
            }
        },
        reset(){
            Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui, réinitialiser le formulaire',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.lines = [];
                        this.form = {
                            payable_type : 'App\\Models\\Invoice',
                            search: null,
                            type: 1, // Crédit par défaut car facture client
                        }
                    }
                });
        },
        deleteRow: function (index) {
            this.lines.splice(index, 1)
        },
        getCurrentSelectedLinesId: function() {
            return this.lines.map(line => line.id);
        },
        getCurrentSelectedLinesCompanyId: function() {
            return this.lines.map(line => line.company_id);
        },
        initInput: function(){
              $("#autocompleteSearchInput").autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.route,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        // Ne pas oublier de ne pas prendre les factures et avoir déjà sélectionnées
                        data: { q: request.term, '!id': this.getCurrentSelectedLinesId().join(';') , 'company_id': this.getCurrentSelectedLinesCompanyId().join(';')  ,'type' : this.arrayType[this.form.payable_type], ... (this.form.payable_type == this.TYPE_PAYABLE_RG ? {'invoice_holdback' : true, 'type' : this.arrayType[0]} : {})},
                        
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.name,
                                    value: item.name,
                                    formatted_total_ttc: this.currency(item.total_ttc),
                                    formated_total_ht: this.currency(item.total_ht),
                                    formated_total_remaining: this.currency(item.total_remaining),
                                })
                            }))
                        }
                    });
                },
                create: function () {
                      $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        var html = `<div class="d-flex align-items-center ix-text-small ix-suggestion-small">
                                              <span><i class="far fa-level-up fa-rotate-90"></i> ${item.full_designation} ${item.company_designation && item.company_designation != null ? '<br> ' + item.company_designation + ' - ' + item.formated_total_remaining : ''}</span>
                                              <span class="ml-auto">${item.formatted_total_ttc}  ${item.holdback && item.holdback != null ? ' - RG : <b>' + item.holdback + '%</b>' : ''}</span>
                                          </div>`

                       
                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.form.search = null
                    } 
                },
                select: (e, item) => {
                    if (item.item) {
                        $(e.target).val("")
                        this.addLine(item.item);
                        this.form.search = null
                    }
                }
            }).focus(() => {
                $("#autocompleteSearchInput").autocomplete("search", '');
            });
        }
    },
    mounted(){
        this.initInput();
        this.typePayments = JSON.parse(this.typePayments);

        const jsonLineBackup = JSON.parse(this.oldLines);
    }
}
</script>
